import { apiGet } from '../../fetch/apiService';

export function getLights(credentialsId) {
	return apiGet(`data-sources/philips_hue/get-lights/${credentialsId}`, {}, { adminApi: true });
}
